import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';

export default function initLogos() {
  const sliders = document.querySelectorAll('.logo-carousel__slider');

  sliders.forEach((slider) => {
    new Splide(slider, {
      type: 'loop',
      perPage: 8,
      gap: '6rem',
      arrows: false,
      pagination: false,
      autoScroll: {
        speed: 0.5,
      },
      breakpoints: {
        1024: {perPage: 4},
        768: {perPage: 3},
        480: {perPage: 2},
      },
    }).mount({AutoScroll});
  });
}
